import PropTypes from 'prop-types';
import ValuePropType from './Value';
export default PropTypes.shape({
  label: ValuePropType.required,
  render: PropTypes.func,
  // Function that can return custom content for the option label
  value: ValuePropType.required
});